import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import {StreamService} from '../services/stream_service';

@Component({
  selector: 'podcast',
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.scss']
})
export class PodcastComponent implements OnDestroy {
  @Output() uploaded: EventEmitter<any> = new EventEmitter();
  @Input() showPodcastIcon: boolean;
  @Input() streamId: string | number;

  podcastUrl: string;
  showPodcastDropdown = false;
  linkCopied = false;
  errorMessage: string;
  loadingData = false;

  constructor(
    private streamService: StreamService,
    private eRef: ElementRef
  ) {}

  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      this.showPodcastDropdown = false;
    }
  }

  togglePodcastDropdown() {
    if (this.streamId) {
      this.showPodcastDropdown = true;
      this.loadingData = true;
      this.streamService.getPodcastUrl(this.streamId).then(res => {
        if (res && res.hasOwnProperty('podCastUrl')) {
          this.podcastUrl = res['podCastUrl'];
          this.loadingData = false;
        }
      }, error => {
        this.loadingData = false;
        const podCastError = error.error;
        if (podCastError.status === 403) {
          this.errorMessage = 'You need to be log-in and also have subscription to have access to this podcast';
        } else {
          this.errorMessage = podCastError.message + ' Please try again later.' || 'Something went wrong.';
        }
      });
    }
  }

  closePodcastPopup() {
    this.showPodcastDropdown = false;
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
  }
}
